import React, { Component } from "react";
import { Button } from "reactstrap";
import WelcomeInfographic from "./../../welcome_infographic.svg";
import Stories from "../../assets/onboarding/Stories.png";
import { staticTitles } from "../../utils/constants";
import { connect } from "react-redux";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { isMobile } from "../../utils/deviceInfo";

import wtEngageImg from "../../assets/onboarding/wtEngageImg.png";
import wtAnalyticsImg from "../../assets/onboarding/wtAnalyticsImg.png";
import wtActionImg from "../../assets/onboarding/wtActionImg.png";
import wtResourceImg from "../../assets/onboarding/wtResourceImg.png";
import wtGroupsImg from "../../assets/onboarding/wtGroupsImg.svg";

// import wtResourceImg from '../../assets/stories/resource.svg'

class OrgOverview extends Component {
  navigate = async (startPage) => {
    const { profile } = this.props.user;
    let { _id } = profile.organizationId;
    this.props.orgChangeSuccess({ startPage });
    axios
      .post(url.storeStartPage, { startPage, id: _id })
      .then(({ data }) => {
        if (profile.orgAdmin) {
          this.props.history.push("/setup/org-chart");
        } else {
          this.props.history.push("/setup/personal-details");
        }
      })
      .catch((err) => {
        console.log(err);
        if (profile.orgAdmin) {
          this.props.history.push("/setup/org-chart");
        } else {
          this.props.history.push("/setup/personal-details");
        }
      });
  };

  navigateStory = (startPage) => {
    let { _id } = this.props.user.profile.organizationId;
    console.log(_id);

    axios
      .post(url.skippedAnalytic, { id: _id, startPage: startPage })
      .then(({ data }) => {
        console.log("skipped setup");
        console.log(data.data.isSetupSkipped);
        let skipped = {
          isSetupSkipped: data.data.isSetupSkipped,
          startPage,
        };
        this.props.orgSetupSkipped({ ...skipped });
        this.props.history.push("/setup/personal-details");
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const {isMaturityModelSignup} = this.props.user.profile.organizationId;
    if(isMaturityModelSignup){
      this.navigateStory("/dei-maturity-model")
    }
  }

  renderView = () => {
    const { name } = this.props.user.profile.organizationId;
    let orgId = this.props.user.profile.organizationId._id;
    const imgWidth = isMobile ? "185.32px" : "271.32px";
    let {
      selectModule,
      isToolkit,
      isPlanning,
      isCultureApp,
      isAnalytics,
      isGroups,
    } = this.props.user.profile.organizationId;
    if (
      selectModule &&
      isToolkit.status == false &&
      isPlanning.status == false &&
      isCultureApp.status == false &&
      isAnalytics.status == false &&
      isGroups.status == false
    ) {
      return (
        <div className="page-title-box">
          <div className="title-text">
            <strong> {name} </strong> Setup Overview
          </div>
          {!isMobile && <hr className="separator-line" />}

          <div className="orgOverviewContent">
            <p>
              No modules have yet been enabled. Please contact your DEI advisor
              to set your organization up
            </p>

            {/* <div className="col-sm-12 setup_modules_container" style={{marginTop:'80px', textAlign: 'center'}}>  

      
    </div>  */}
          </div>
        </div>
      );
    } else {
      return (
        <div className="page-title-box">
          <div className="title-text">
            <strong> {name} </strong> Setup Overview
          </div>
          {!isMobile && <hr className="separator-line" />}

          <div className="orgOverviewContent">
            <p>
              Select a module below to land on after your set up is complete.
            </p>

            <div
              className="col-sm-12 setup_modules_container"
              style={{ marginTop: "3em", textAlign: "center" }}
            >
              {(isPlanning && isPlanning.status) || selectModule != true ? (
                <div
                  className="storyContainer"
                  onClick={() => this.navigateStory("/home/my-activity")}
                >
                  <div className="storyTemplate wtActionImg">
                    <img src={wtActionImg} className="templateImage" />
                    Planning
                  </div>
                </div>
              ) : null}

              {(isAnalytics && isAnalytics.status) || selectModule != true ? (
                <div
                  className="storyContainer"
                  onClick={() => this.navigate("/home/analytics/all")}
                >
                  <div className="storyTemplate wtAnalyticsImg">
                    <img src={wtAnalyticsImg} className="templateImage" />
                    Analytics
                  </div>
                </div>
              ) : null}

              {(isCultureApp && isCultureApp.status) || selectModule != true ? (
                <div
                  className="storyContainer"
                  onClick={() => this.navigateStory("/home/stories")}
                >
                  <div className="storyTemplate wtEngageImg">
                    <img src={wtEngageImg} className="templateImage" />
                    Culture App
                  </div>
                </div>
              ) : null}

              {(isGroups && isGroups.status) || selectModule != true ? (
                <div
                  className="storyContainer"
                  onClick={() =>
                    this.navigateStory(`/home/groups/${orgId}/discover`)
                  }
                >
                  <div className="storyTemplate wtGroupsImg">
                    <img src={wtGroupsImg} className="templateImage" />
                    Groups
                  </div>
                </div>
              ) : null}

              {(isToolkit && isToolkit.status) || selectModule != true ? (
                <div
                  className="storyContainer"
                  onClick={() => this.navigateStory("/home/toolkit/all")}
                >
                  <div className="storyTemplate">
                    <img src={wtResourceImg} className="templateImage" />
                    Resources
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    const { profile } = this.props.user;
    const { name } = this.props.user.profile.organizationId;

    const imgWidth = isMobile ? "185.32px" : "271.32px";
    let {
      isToolkit,
      isPlanning,
      isCultureApp,
      isAnalytics,
    } = this.props.user.profile.organizationId;

    return this.renderView();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgSetupSkipped: (data) => dispatch(actionCreators.orgSetupSkipped(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgOverview);
